module.exports = __webpack_public_path__ + "img/sandraweissflog.3980c5b2.jpeg";